/**
 * Javascript file for the page with details on the current technology. 
 * @author Adrian Rebmann, Yannik Sprengart, Eduardo Parducci, Andreas Emrich, Sebastian Grill, Steffen Schuhmann
 */

import {
  getDigitalOfferByHash,
} from "../../../../api";

import auth from "../../../../auth";

// Import config from correct environment
var environment = process.env.NODE_ENV;
var config = require(`../../../../../config/${environment}.json`);

export default {
  name: "OfferDetail",
  props: ["hash"],

  /**
   * The vue instance's data object.
   * @property {boolean} loggedIn - Status of the user's login. 
   * @property {boolean} offer - The current offers for the technology.
   * @property {boolean} request - The current request for the technology.
   * @property {object} digitalOffer - The digitalOffer item.
   * @property {boolean} loading - Information is currently being processed.
   * @property {boolean} showDialog - Visibility of the "add this technology to your company's profile" dialog.
   * @property {any[]} projects - The projects for the technology.
   * @property {boolean} adding - Information about the technology is currently being updated.
   * @property {string} imageLink - The base path for the image link.
   */
  data() {
    return {
      loggedIn: auth.loggedIn(),
      offer: false,
      request: false,
      digitalOffer: null,
      loading: false,
      showDialog: false,
      adding: false,
      imageLink: `${config.deployment}/static/`, //images are not uploaded via the system but manually
    };
  },

  /**
   * Expressions to watch.
   */
  watch: {
    $route: "fetchData"
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.fetchData();
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
  
 

    /**
     * Shortens the description.
     * @param {*} desc - The description.
     */
    shorten(desc) {
      var res = desc.substring(0, 300) + "...";
      return res;
    },

    /**
     * Retrieves the technology's data.
     */
    fetchData() {
      this.loading = true;
      this.digitalOffer = null;

      getDigitalOfferByHash(this.hash).then(res =>{
        this.digitalOffer = res;
        console.log(this.digitalOffer);
      })
    },

    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Sets a placeholder image in the element.
     * @param {*} e  - The element where the placeholder image is to be set.
     */
    setAltImg(e) {
      e.target.src = require("../../../../assets/tech-placeholder.png");
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/search/offersearch/detail/offerdetail.js